module.exports = __webpack_public_path__ + "static/media/Lato-Black.bba14d8e.woff2";